var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChartIconStackedBarComboChartColored(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43034",
    "data-name": "Group 43034",
    transform: "translate(-416 -325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42607",
    "data-name": "Group 42607",
    transform: "translate(416 325)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6222",
    "data-name": "Rectangle 6222",
    width: 30,
    height: 30,
    rx: 4,
    fill: "#f45e29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Horizontal_bar_chart",
    "data-name": "Horizontal bar chart",
    transform: "translate(418 330)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 22.105,
    height: 22.105,
    transform: "translate(2 -1)",
    fill: "#6a6a6a",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_37810",
    "data-name": "Group 37810",
    transform: "translate(5.105 2.895)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42823",
    "data-name": "Group 42823",
    transform: "translate(-0.105 -0.895)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70241",
    "data-name": "Path 70241",
    d: "M-1.226,285.09v16h16",
    transform: "translate(1.226 -285.09)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    y1: 1.825,
    transform: "translate(4 10.175)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    y1: 4.825,
    transform: "translate(7 7.175)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    y1: 3.825,
    transform: "translate(11 8.175)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    y1: 6.825,
    transform: "translate(15 5.175)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_70475",
    "data-name": "Path 70475",
    d: "M3.015,4.96,7.549.425,11.007,4.28,14.635.425",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIconStackedBarComboChartColored);
export default __webpack_public_path__ + "static/media/chart-icon-stacked-bar-combo-chart-colored.09ba7e6e.svg";
export { ForwardRef as ReactComponent };